import { Outlet, Navigate } from 'react-router-dom'
import { useAuth } from '../auth/useAuth'

/**
 * Route guard for the MS-866 AC6 entitlements-fetch-failure state.
 *
 * A nested layout route (wraps everything except Home via <Outlet/>) in
 * routes.tsx. A failed entitlements lookup redirects every other
 * surface to `/home`, which shows the coffee-cup banner in place of its cards
 * (see pages/Home.tsx).
 *
 * UX gate only, NOT the security boundary — server-side checks remain the
 * enforcement layer.
 */
export function RequireEntitlements() {
  const { entitlementsAvailable, entitlementsPending } = useAuth()
  /* Hold, don't redirect, while pending (Decision 3 — mirrors
     RequireSectionAccess.isRoleResolved): AppShell renders routes as soon as
     the cached session flag is set, so a profile written before
     `entitlementsAvailable` existed would otherwise bounce a legitimate deep
     link to /home before the mount probe lands — and that redirect is never
     undone. */
  if (entitlementsPending) return null
  return entitlementsAvailable ? <Outlet /> : <Navigate to="/home" replace />
}
